<template>
  <div class="container-fluid" v-if="category!=null">
    <div class="row justify-content-between my-3">
      <div class="col">
        <h4>{{category.name}}</h4>
      </div>

    </div>
    <div v-if="carMarks.length==0" class="justify-content-between">
      <div>
        <h3>Машины ангилал бөөнөөөр оруулаx</h3>
      </div>
      <div>
        <p>
          Доорx форматаар оруулна уу!!!. Жишээ нь:
          <br />toyota ;alex ;2004.4;1500cc, Урдаа, Автомат,
          <br />;;;1500cc, Бүх дугуйн, Автомат,
        </p>
        <div class="form-group">
          <textarea
            rows="10"
            v-model.trim="dataText"
            class="form-control"
            placeholder="Машины ангилалын мэдээлэл энд xуулаx"
          />
        </div>

        <button type="button" class="btn btn-primary" @click="addBulk">Нэмэх</button>
        <hr />
      </div>
    </div>

    <div class="row">
      <div class="col col-6 card shadow my-4">
        <div class="card-header py-3">
          <h6
            class="m-0 font-weight-bold text-primary"
          >Жагсаалт ({{this.carMarks.length}})</h6>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive" v-if="carMarks!=null && carMarks.length>0">
            <button class="btn btn-success" @click="_saveAll">Бүгдийг хадгалах</button>
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Марк</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(data, index) in carMarks">
                  <td>{{index+1}}</td>
                  <td>
                    
                    <span class="text-primary">{{data.name}}</span>
                    ({{data.years.length}})
                    <p class="margin-bottom: 0rem!important" v-for="(year, indx) in data.years">
                      <span style="font-weight: bold;">{{indx+1}}.</span>
                      <span class="text-danger"><span style="font-weight: bold;"> {{year.name}}</span> [{{year.models.length}}]</span>
                      <span v-for="(mod,ind) in year.models" style="display: block;">
                        <span style="font-weight: bold;">&nbsp;{{ind+1}}.</span> {{mod.name}}
                        <!-- <span class="text-danger" style="font-weight: bold;">,</span> -->
                      </span>
                    </p>
                  </td>
                  <td>
                    <!-- <button class="btn btn-danger" @click="deleteTeacher(teacher, index)">устгах</button> -->
                    <!-- <button class="btn btn-warning" @click="_edit(data)">засах</button> -->
                    <button v-if="!loading" class="btn btn-warning btn-sm" @click="_save(data,index)">Xадгалаx</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="alert alert-info text-center">Одоогоор мэдээлэл ороогүй байна.</div>
        </div>
      </div>
      <div class="col col-6 card shadow my-4">
        <div class="card-header py-3">
          <h6
            class="m-0 font-weight-bold text-primary"
          >Хадгалагдсан Жагсаалт ({{marks.length}})</h6>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive" v-if="marks!=null && marks.length>0">
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Марк</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(data, index) in marks">
                  <td>{{index+1}}</td>
                  <td>
                    <div class="row" v-if="data.edit!=true">       
                      <span class="col text-primary">{{data.name}} ({{data.years.length}})</span>
                      <span class="col-auto text-success" @click="data.edit=!data._edit"><i class="fas fa-edit" style="cursor:pointer"></i></span>
                      <span class="col-auto text-danger" @click="deleteMark(data)"><i class="fas fa-trash" style="cursor:pointer"></i></span>
                    </div>
                    <div v-else class="row">
                      <div class="col">
                        <input v-model="data.name" class="form-control" @keyup="data.changed=true;"/>
                      </div>
                      <div class="col-auto" v-if="data.changed==true">
                        <button class="btn btn-success btn-sm" @click="changeMark(data)">хадгалах</button>
                      </div>
                      <div class="col-auto">
                        <button class="btn btn-warning btn-sm" @click="data.edit=false;">болих</button>
                      </div>
                    </div>
                    <ul style="list-style-type:none">
                      <li class="margin-bottom: 1px!important" v-for="(year, indx) in data.years">
                        
                        <div class="row" v-if="year.edit!=true">
                          <span class="col">
                            <span style="font-weight: bold;">{{indx+1}}.</span>
                            <span style="font-weight: bold;" class=" text-danger"> {{year.name}}</span>
                            [{{year.models.length}}]
                          </span>
                          <span class="col-auto text-success" @click="year.edit=true"><i class="fas fa-edit" style="cursor:pointer"></i></span>
                          <span class="col-auto text-danger" @click="deleteMark(year)"><i class="fas fa-trash" style="cursor:pointer"></i></span>
                        </div>
                        <div v-else class="row">
                          <div class="col flex">
                            <input v-model="year.name" class="form-control" @keyup="year.changed=true;"/>
                          </div>
                          <div class="col-auto" v-if="year.changed==true">
                            <button class="btn btn-success btn-sm" @click="changeMark(year)">хадгалах</button>
                          </div>
                          <div class="col-auto">
                            <button class="btn btn-warning btn-sm" @click="year.edit=false;">болих</button>
                          </div>
                        </div>

                        <div>
                          <span v-for="(mod,ind) in year.models" style="display: block;">
                            <div class="row" v-if="mod.edit!=true">
                              <span class="col">&nbsp;{{ind+1}}.&nbsp;&nbsp;{{mod.name}}</span> 
                              <!-- <span class="text-danger" style="font-weight: bold;">,</span> -->
                              <span class="col-auto text-success" @click="mod.edit=true;"><i class="fas fa-edit" style="cursor:pointer"></i></span>
                              <span class="col-auto text-danger" @click="deleteMark(mod)"><i class="fas fa-trash" style="cursor:pointer"></i></span>
                            </div>
                            <div v-else class="row">
                              <div class="col flex">
                                <input v-model="mod.name" class="form-control" @keyup="mod.changed=true;"/>
                              </div>
                              <div class="col-auto" v-if="mod.changed==true">
                                <button class="btn btn-success btn-sm" @click="changeMark(mod)">хадгалах</button>
                              </div>
                              <div class="col-auto">
                                <button class="btn btn-warning btn-sm" @click="mod.edit=false;">болих</button>
                              </div>
                            </div>
                          </span>
                        </div>
                      </li>
                    </ul>
                  </td>
             
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="alert alert-info text-center">Одоогоор мэдээлэл ороогүй байна.</div>
        </div>
      </div>
    </div>

    <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
 
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

export default {
  data() {
    return {
      category:null,
      datas: [],
      dataText: null,
      tmpDatas: [],
      carMakers: [],
      carMarks: [],
      loading:false,
      marks:[]
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  methods: {
    _getData() {
      fb.db.collection('cartypes').doc(this.categoryId).get().then(doc=>{
        if(doc.exists){
          this.category=doc.data();
          this.category.id=doc.id;
          this.getDatas();
        }
      });

    },
    async getDatas(){
      var categoryRef=fb.db.collection('cartypes').doc(this.categoryId);
      categoryRef.collection("marks").orderBy("name","asc").onSnapshot(markDocs=>{
        this.marks=[];
        markDocs.forEach(markdoc=>{
          let mark=markdoc.data();
          mark.id=markdoc.id;
          mark.years=[];
          mark.edit=false;
          mark.changed=false;
          mark.ref=markdoc.ref;
          this.marks.push(mark);

          markdoc.ref.collection('years').orderBy("name").onSnapshot(yearDocs=>{
            mark.years=[];
            yearDocs.forEach(yearDoc=>{
              let year=yearDoc.data();
              year.id=yearDoc.id;
              year.models=[];
              year.edit=false;
              year.changed=false;
              year.ref=yearDoc.ref;
              mark.years.push(year);

              yearDoc.ref.collection('models').onSnapshot(modelDocs=>{
                year.models=[];
                modelDocs.forEach(modelDoc=>{
                  let model=modelDoc.data();
                  model.id=modelDoc.id;
                  model.edit=false;
                  model.changed=false;
                  model.ref=modelDoc.ref;
                  year.models.push(model);
                });
              });

            });

          });

        });
      });
      

    },
    _edit(teacher) {
      this.$router.push({
        name: "TeacherAdd",
        params: { teacherId: teacher.id }
      });
    },
    async _save(data, index) {
      
      console.log(data);
      if(data!=null && data!=undefined){
        this.loading=true;
        var tmpMark = Object.assign({}, data);
        delete tmpMark.years;
        tmpMark.createdAt=new Date();
        tmpMark.created=fb.db.collection("users").doc(this.currentUser.uid);

        var markRef=fb.db.collection("cartypes").doc(this.categoryId).collection("marks").doc();
        await markRef.set(tmpMark);
        fb.db.collection("cartypes").doc(this.categoryId).update({'numberOfMarks':fb.firestore.FieldValue.increment(1)});
        markRef.update({'numberOfYears':fb.firestore.FieldValue.increment(data.years.length)});

        if(data.years!=null && data.years.length>0){
          for (const year of data.years) {
            var tmpYear= Object.assign({}, year);
            delete tmpYear.models;
            var yearRef= markRef.collection("years").doc();
            await yearRef.set(tmpYear);
            yearRef.update({'numberOfModels':fb.firestore.FieldValue.increment(year.models.length)});
            if(year.models!=null && year.models.length>0){
              for (const model of year.models) {
                await yearRef.collection("models").doc().set(model);
                if(model!=null && model.name.includes(",")){
                  yearRef.update( {
                    "enginePowers":fb.firestore.FieldValue.arrayUnion(model.name.substring(0, model.name.indexOf(",")))
                  });

                }
                
              }
            }
          }
        }
        this.loading=false;
      }
      this.carMarks.splice(index,1);

    },
    async _saveAll() {
      
      if(this.carMarks!=null && this.carMarks.length>0){
        var r = confirm("Бүгдийг хадгалах уу. Та хадгалагдаж дуустал вэбээс гаралгүй хүлээнэ үү");
        if (r == true) {
          var i=0;
          for(const value of this.carMarks){
            await this._save(value, i);
            i++;
          }
          alert("Амжилттай хадгаллаа");
        } 
      }

    },
    addBulk() {
      var _this = this;
      var currentMark = null;
      var currentYear = null;

      if (this.dataText != null && this.dataText != "") {
        //TODO
        var arrayOfLines = this.dataText.match(/[^\r\n]+/g);

        arrayOfLines.forEach(value => {
          var lineArray = value.split(";");
          //_this.tmpDatas.push(lineArray);

          if (lineArray.length > 0 && lineArray[0] != "")
            _this.carMakers.push(lineArray[0]);

          if (lineArray.length > 1 && lineArray[1] != "") {
            currentMark = { name: lineArray[1], years: [] };
            _this.carMarks.push(currentMark);
          } 
          if (
            lineArray.length > 2 &&
            lineArray[2] != "" &&
            currentMark != null
          ) {
            currentYear = { name: lineArray[2], models: [] };
            currentMark.years.push(currentYear);
          } 
          if (
            lineArray.length > 3 &&
            lineArray[3] != "" &&
            currentYear != null
          ) {
            if(lineArray[3].trim()!=", , ,") 
                currentYear.models.push({name:lineArray[3].trim()});
          }

        });
        this.dataText = "";
      }
    },
    deleteTeacher(teacher, index) {
      //   if (teacher != null && teacher.id != null) {
      //     fb.db
      //       .collection("teachers")
      //       .doc(teacher.id)
      //       .delete();
      //     this.teachers.splice(index, 1);
      //   }
    },
    changeMark(mark){
      if(mark.ref!=null){
        mark.ref.update({name: mark.name});
      }
    },
    deleteMark(mark){
      if(mark!=null && mark.ref!=null){
        var r = confirm("Та "+ mark.name+" устгахдаа итгэлтэй байна уу.");
        if (r == true) {
          mark.ref.delete();
        } 
      }
    }

  },
  created() {
    if(this.categoryId!=null && this.categoryId!='')
      this._getData();
  },
  props: {
    categoryId: {
      required: true
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    }
  }
};
</script>
